"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyTabs = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../utils/classFunctions");
require("./index.scss");
const className = 'tabs';
/** @deprecated Use Tabs */
class LegacyTabs extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            openedTabIndex: this.props.activeTab || 0,
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.activeTab !== undefined && prevState.openedTabIndex !== this.props.activeTab) {
            this.setState({ openedTabIndex: this.props.activeTab });
        }
    }
    render() {
        const { title, tabs, modificators, disabled } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        const getNavItemClassNames = (index) => (0, classFunctions_1.getClassNames)(`${className}__nav-item`, [
            index === this.state.openedTabIndex ? 'active' : undefined,
            disabled ? 'disabled' : undefined,
            this.props.tabs[index].hasError ? 'has-error' : undefined,
        ]);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__header` },
                react_1.default.createElement("div", { className: `${className}__nav` }, tabs.map((item, index) => (react_1.default.createElement("button", { type: 'button', onClick: () => {
                        this.setState({ openedTabIndex: index }, () => this.props.onTabChange(index));
                    }, disabled: disabled, key: `tab::${title}:${index}:${item.title}`, className: getNavItemClassNames(index) }, item.title))))),
            react_1.default.createElement("div", { className: `${className}__content` }, this.state.openedTabIndex !== null
                ? tabs[this.state.openedTabIndex].content
                : null)));
    }
}
exports.LegacyTabs = LegacyTabs;
LegacyTabs.defaultProps = {
    onTabChange: () => { },
};
//# sourceMappingURL=legacy.js.map